import template from './insurance-state-detail.html';
import controller from './insurance-state-detail.controller';

let insuranceStateDetailComponent = {
  bindings: {},
  template,
  controller
};

export default insuranceStateDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance-state-detail.component.js